module.exports = __webpack_public_path__ + "static/media/happy-active.78a5dd14.svg";